var ReorderProductsService = /** @class */ (function () {
    function ReorderProductsService($http, $log) {
        'ngInject';
        this.$http = $http;
        this.$log = $log;
    }
    ReorderProductsService.prototype.getReorderProducts = function (pageNumber, pageSize, sortBy, sortDirection, query, sortDays) {
        var self = this;
        var today = new Date();
        var DateTo = today.getMonth() + 1 + '/' + today.getDate() + '/' + (1900 + today.getYear());
        var DateFrom;
        if (sortDays > 0) {
            var startDate = new Date();
            startDate.setDate(startDate.getDate() - ~~sortDays);
            DateFrom = startDate.getMonth() + 1 + '/' + startDate.getDate() + '/' + (1900 + startDate.getYear());
        }
        var queryParams = {
            pageNumber: pageNumber ? pageNumber : 1,
            pageSize: pageSize ? pageSize : 25,
            sortBy: sortBy ? sortBy : "orderDate",
            sortDirection: sortDirection ? "ascending" : "descending",
            query: query ? query : null,
            dateFrom: DateFrom ? DateFrom : null,
            dateTo: DateFrom ? DateTo : null,
        };
        return this.$http.get('api/account/reorderProducts', { params: queryParams })
            .then(function success(response) {
            return response.data.response;
        }, function error(response) {
            self.$log.error('error response.....', response);
        });
    };
    return ReorderProductsService;
}());
export { ReorderProductsService };
//# sourceMappingURL=reorder-products.service.js.map